import { render } from "./ApiKeySkeleton.vue?vue&type=template&id=3901376b"
import script from "./ApiKeySkeleton.vue?vue&type=script&lang=js"
export * from "./ApiKeySkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script